__turbopack_context__.v({
  "footer": "b2b-otp-module-scss-module__bCVU6G__footer",
  "info": "b2b-otp-module-scss-module__bCVU6G__info",
  "input": "b2b-otp-module-scss-module__bCVU6G__input",
  "sub-title": "b2b-otp-module-scss-module__bCVU6G__sub-title",
  "title": "b2b-otp-module-scss-module__bCVU6G__title",
});
